import { useEffect, useState } from "react";

import { NormsHttpService, INorm } from "@/shared/services/norms/norms-http.service";
import { getFriendlyErrorMessage } from "@/shared/services/http";
import { notification } from "antd";

export function useGetTestNormsHook(testId: number) {
  const [norms, setNorms] = useState<INorm[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchNorms = async () => {
      try {
        setIsLoading(true);
        const norms = await NormsHttpService.getTestNorms(testId);
        setNorms(norms);
      } catch (error) {
        const message = getFriendlyErrorMessage(error) ?? "Failed to load norms for test. Please try again.";
        notification.error({ message });
      } finally {
        setIsLoading(false);
      }
    };

    fetchNorms();
  }, [testId]);

  return { norms, isLoading };
}
